import { Link } from "react-router-dom";

export interface Crumb {
  label: string;
  to?: string;
}

export default function Breadcrumbs({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航" className="flex flex-wrap items-center gap-2 text-xs text-foreground-500">
      {items.map((item, index) => (
        <span key={`${item.label}-${index}`} className="flex items-center gap-2">
          {index > 0 && <i className="ri-arrow-right-s-line text-foreground-600" />}
          {item.to ? (
            <Link to={item.to} className="transition-colors hover:text-primary-300">
              {item.label}
            </Link>
          ) : (
            <span className="text-foreground-300">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}